// src/components/About.tsx

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

export const About = () => {
  const [aboutUrl, setAboutUrl] = useState<string>("/site-uploads/6d92d6a1-9464-41dd-a33b-f21bd60554bd.png");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        // CHANGED: /api/about-image -> /api/site-image?id=about
        const r = await fetch("/api/site-image?id=about", { method: "GET" }); 
        const j = await r.json();
        if (alive && j?.ok && j.url) setAboutUrl(j.url);
      } catch { /* ignore to avoid breaking existing behavior */ }
    })();
    return () => { alive = false; };
  }, []);

  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section 1 - Seema Acharya — The Artist Behind the Magic */}
        <div className="mb-16">
          <h1 className="text-4xl lg:text-5xl text-[var(--heading-color)] mb-12 text-center">
            Seema Acharya — The Artist Behind the Magic
          </h1>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <div className="space-y-6">
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Every cake begins with a story. For Seema Acharya, renowned cake artist and founder of Frosted Cake Art in Chagrin Falls, OH, that story is one of artistry, imagination, and devotion to craft. Her work—spanning sculpted showpieces, towering wedding cakes, and avant-garde sugar art—has earned her recognition on Netflix's Sugar Rush, Food Network competitions, and in the pages of Cake Masters Magazine.
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed font-medium italic">
                  Seema is not just a cake designer—she is a storyteller. Her sugar creations are celebrated for their sculptural elegance, meticulous detail, and the ability to capture the essence of every occasion.
                </p>
              </div>
            </div>
            <div className="order-1 lg:order-2">
              <div className="rounded-2xl overflow-hidden shadow-lg bg-white/90 backdrop-blur-sm elegant-shadow p-3">
                <img
                  src={aboutUrl} 
                  alt="Seema Acharya, cake designer and sugar artist, founder of Frosted Cake Art"
                  className="rounded-xl w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>


        {/* Section 2 - An Experience, Not Just a Cake */}
        <div className="mb-16">
          <h2 className="text-3xl text-[var(--heading-color)] mb-6 text-center">
            An Experience, Not Just a Cake
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto text-center mb-6">
            At Frosted Cake Art, the journey is as meaningful as the cake itself. For our couples, the wedding cake tasting is a cherished part of the process—a moment to pause, dream, and savor. Guests are welcomed into a warm, personalized consultation where they sample flavors, discuss inspirations, and explore designs that reflect their unique story.
          </p>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto text-center">
            Seema listens with care, sketches ideas, and transforms visions into edible art. The process is intimate, refined, and memorable—ensuring that by the time your wedding day arrives, the cake feels like it was created exclusively for you.
          </p>
        </div>

        {/* Section 3 - Rooted in Community, Licensed for Trust */}
        <div className="mb-16">
          <h2 className="text-3xl text-[var(--heading-color)] mb-6 text-center">
            Rooted in Community, Licensed for Trust
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-4xl mx-auto text-center">
            Frosted Cake Art is proudly local and licensed, serving Chagrin Falls and the greater Cleveland community with artistry backed by professionalism. Being licensed assures every client that each creation is made with the highest standards of safety, quality, and care. Choosing us means supporting a local business deeply rooted in the community, while experiencing the polish of world-class sugar artistry.
          </p>
        </div>

        {/* Closing Statement */}
        <div className="mb-16 text-center">
          <div
            className="rounded-2xl p-8 max-w-4xl mx-auto"
            style={{ background: "var(--about-card-tint, rgba(230, 164, 164, 0.10))" }}
          >
            <p className="text-xl text-[var(--heading-color)] font-medium italic leading-relaxed">
              ✨ Frosted Cake Art isn't just about cake. It's about wonder, memory, and art that you can taste.
            </p>
          </div>
        </div>

        {/* Section 5 - Let's Create Together */}
        <div className="text-center">
          <h3 className="text-3xl text-[var(--heading-color)] mb-6">
            Let's Create Together
          </h3>
          <Button
            onClick={scrollToContact}
            size="lg"
            className="
              !bg-[var(--about-btn-bg)]
              !text-[var(--about-btn-text)]
              hover:!bg-[var(--about-btn-hover-bg)]
              hover:!text-[var(--about-btn-hover-text)]
              font-semibold px-10 py-4 text-lg elegant-shadow transition-elegant rounded-xl
            "
          >
            Begin Your Cake Story
          </Button>
        </div>

      </div>
    </section>
  );
};